module.exports = __webpack_public_path__ + "assets/images/5f933600aa786b380f5e704c849354a6.png";